import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';

const collageImages = {
  'hand-tufted': [
    '/images/WhatsApp Image 2026-01-25 at 18.36.26 (1).png',
    '/images/WhatsApp Image 2026-01-25 at 18.36.26 (2).png',
    '/images/WhatsApp Image 2026-01-25 at 18.36.26 (3).png',
    '/images/WhatsApp Image 2026-01-25 at 18.36.26 (4).png',
    '/images/WhatsApp Image 2026-01-25 at 18.36.26 (5).png',
    '/images/WhatsApp Image 2026-01-25 at 18.36.26 (6).png',
    '/images/WhatsApp Image 2026-01-25 at 18.36.26 (7).png',
    '/images/WhatsApp Image 2026-01-25 at 18.36.26 (8).png',
    '/images/WhatsApp Image 2026-01-25 at 18.36.26.png'
  ],
  'hand-knotted': [
    '/images/WhatsApp Image 2026-01-25 at 18.13.16 (1).jpeg',
    '/images/WhatsApp Image 2026-01-25 at 18.13.16 (2).jpeg',
    '/images/WhatsApp Image 2026-01-25 at 18.13.16 (3).jpeg',
    '/images/WhatsApp Image 2026-01-25 at 18.13.16 (4).jpeg',
    '/images/WhatsApp Image 2026-01-25 at 18.13.16 (5).jpeg',
    '/images/WhatsApp Image 2026-01-25 at 18.13.16 (6).jpeg',
    '/images/WhatsApp Image 2026-01-25 at 18.13.16 (7).jpeg',
    '/images/WhatsApp Image 2026-01-25 at 18.13.16.jpeg',
    '/images/hk.png'
  ]
};

const categoryNames = {
  'hand-tufted': 'Hand Tufted Rugs & Carpets',
  'hand-knotted': 'Hand Knotted Rugs & Carpets'
};

const categorySeo = {
  'hand-tufted': {
    title: 'Hand Tufted Rugs | Wovn Rugss – wovnrugss.com | Woven rugs, Wovnrugs',
    metaDescription: 'Wovn Rugss (wovnrugss.com) – hand tufted woven rugs, wovn rugs, wovnrugs. Modern, luxury wovenrugs crafted with precision. Shop handcrafted rugs.',
    h1: 'Hand Tufted Rugs Collection',
    intro: 'Our hand-tufted woven rugs combine skilled craftsmanship with contemporary design. Each piece is crafted with precision for durability, style, and comfort—ideal for modern living rooms, bedrooms, and elegant interiors. Wovn Rugss · wovnrugss.com · wovnrugs, wovenrugs'
  },
  'hand-knotted': {
    title: 'Hand Knotted Rugs | Wovn Rugss – wovnrugss.com | Woven rugs, Wovnrugs',
    metaDescription: 'Wovn Rugss (wovnrugss.com) – hand knotted woven rugs, wovn rugs, wovnrugs. Luxury wovenrugs, heirloom-quality. Shop handcrafted rugs.',
    h1: 'Hand Knotted Rugs Collection',
    intro: 'Our hand-knotted woven rugs embody timeless artistry and superior craftsmanship. Each piece is 100% handmade by skilled artisans—ideal for luxury homes, villas, and designer interiors. Wovn Rugss · wovnrugss.com · wovnrugs, wovenrugs'
  }
};

const ProductsList = () => {
  const { category: categoryParam } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedImage, setSelectedImage] = useState(null);

  // Support clean URLs: /hand-tufted-rugs, /hand-knotted-rugs, or /products/:category
  const category = location.pathname === '/hand-tufted-rugs'
    ? 'hand-tufted'
    : location.pathname === '/hand-knotted-rugs'
    ? 'hand-knotted'
    : categoryParam || null;

  // Get images for current category
  const currentCollageImages = collageImages[category] || collageImages['hand-knotted'];

  useEffect(() => {
    if (!category || !categorySeo[category]) return;
    const seo = categorySeo[category];
    document.title = seo.title;
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) metaDesc.setAttribute('content', seo.metaDescription);
    return () => {
      document.title = 'Wovn Rugss | Luxury Handcrafted Rugs – wovnrugss.com';
      const defaultDesc = 'Wovn Rugss – wovnrugss.com. Woven rugs, wovn rugs, wovnrugs, wovenrugs. Premium handcrafted & luxury rugs. Shop wovenruggs at wovnrugss.com.';
      const m = document.querySelector('meta[name="description"]');
      if (m) m.setAttribute('content', defaultDesc);
    };
  }, [category]);

  // Breadcrumb schema for category pages (SEO) - only for known categories
  useEffect(() => {
    if (category !== 'hand-tufted' && category !== 'hand-knotted') return;
    const breadcrumb = {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: 'Home', item: 'https://www.wovnrugss.com/' },
        { '@type': 'ListItem', position: 2, name: category === 'hand-tufted' ? 'Hand Tufted Rugs' : 'Hand Knotted Rugs', item: `https://www.wovnrugss.com/${category === 'hand-tufted' ? 'hand-tufted-rugs' : 'hand-knotted-rugs'}` }
      ]
    };
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(breadcrumb);
    script.id = 'breadcrumb-schema';
    document.head.appendChild(script);
    return () => {
      const el = document.getElementById('breadcrumb-schema');
      if (el) el.remove();
    };
  }, [category]);

  const handleBackClick = () => {
    navigate('/');
    // Scroll to products section after navigation
    setTimeout(() => {
      const element = document.getElementById('products');
      if (element) {
        const headerHeight = window.innerWidth >= 768 ? 96 : 80;
        const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
        const offsetPosition = elementPosition - headerHeight;
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
        // Update URL hash
        window.history.pushState(null, '', '#products');
      }
    }, 100);
  };

  if (!category) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-white via-gray-50 to-white">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Category not found</h2>
          <button
            onClick={() => navigate('/')}
            className="bg-gradient-to-r from-amber-600 to-orange-600 text-white px-6 py-3 rounded-full font-bold hover:from-amber-700 hover:to-orange-700 transition-all"
          >
            Go to Home
          </button>
        </div>
      </div>
    );
  }

  const categoryName = categoryNames[category] || category;
  const seo = categorySeo[category];

  return (
    <>
      <section
        className="bg-gradient-to-b from-white via-gray-50 to-white pt-6 sm:pt-8 md:pt-12 pb-12 sm:pb-20 md:pb-24 min-h-screen"
      >
        <div className="container mx-auto px-4 sm:px-6 w-full max-w-7xl">
          {/* Back Button */}
          <button
            onClick={handleBackClick}
            className="mb-6 sm:mb-8 flex items-center gap-2 text-gray-700 hover:text-amber-600 transition-all duration-300 font-semibold group text-sm sm:text-base"
          >
            <svg className="w-4 h-4 sm:w-5 sm:h-5 transform group-hover:-translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
            <span>Back to Products</span>
          </button>

          {/* Header - H1 for category page SEO */}
          <div className="text-center mb-8 sm:mb-12 md:mb-16">
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold text-gray-900 mb-4 sm:mb-6 px-4">
              <span className="bg-gradient-to-r from-amber-600 to-orange-600 bg-clip-text text-transparent">
                {seo ? seo.h1 : categoryName}
              </span>
            </h1>
            <p className="text-base sm:text-lg md:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed px-4">
              {seo ? seo.intro : 'Explore our exquisite collection of handcrafted rugs'}
            </p>
          </div>

          {/* Content Section - Hand Knotted Rugs */}
          {category === 'hand-knotted' && (
            <div className="mb-12 sm:mb-16 space-y-8 sm:space-y-12">
              {/* Introduction */}
              <div className="max-w-4xl mx-auto text-center px-4">
                <p className="text-base sm:text-lg md:text-xl text-gray-700 leading-relaxed mb-4">
                  At Wovn Rugss, we create luxury hand-knotted rugs that embody timeless artistry, precision, and superior craftsmanship. Each rug is <strong>100% handmade and hand knotted</strong> by skilled artisans, using traditional techniques passed down through generations.
                </p>
                <p className="text-base sm:text-lg md:text-xl text-gray-700 leading-relaxed">
                  Crafted from premium natural materials such as wool and silk, Wovn Rugss hand-knotted rugs offer exceptional durability, intricate detailing, and refined elegance—perfect for luxury homes, villas, hotels, and designer interiors worldwide.
                </p>
              </div>

              {/* Divider */}
              <div className="flex items-center justify-center max-w-4xl mx-auto">
                <div className="flex-1 h-px bg-gradient-to-r from-transparent via-amber-300 to-transparent"></div>
                <div className="mx-4 w-2 h-2 bg-amber-600 rounded-full"></div>
                <div className="flex-1 h-px bg-gradient-to-r from-transparent via-amber-300 to-transparent"></div>
              </div>

              {/* Why Choose Section */}
              <div className="max-w-4xl mx-auto px-4">
                <h3 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-4 sm:mb-6 text-center">
                  Why Choose Hand-Knotted Rugs from Wovn Rugss?
                </h3>
                <div className="bg-gradient-to-br from-amber-50 via-orange-50 to-amber-50 rounded-2xl p-6 sm:p-8 md:p-10 shadow-lg">
                  <ul className="space-y-3 sm:space-y-4">
                    <li className="flex items-start gap-3 sm:gap-4">
                      <div className="flex-shrink-0 w-5 h-5 sm:w-6 sm:h-6 bg-gradient-to-br from-amber-600 to-orange-600 rounded-full flex items-center justify-center mt-1">
                        <svg className="w-3 h-3 sm:w-4 sm:h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                        </svg>
                      </div>
                      <span className="text-base sm:text-lg text-gray-800"><strong>100% Handmade Hand-Knotted Rugs</strong></span>
                    </li>
                    <li className="flex items-start gap-3 sm:gap-4">
                      <div className="flex-shrink-0 w-5 h-5 sm:w-6 sm:h-6 bg-gradient-to-br from-amber-600 to-orange-600 rounded-full flex items-center justify-center mt-1">
                        <svg className="w-3 h-3 sm:w-4 sm:h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                        </svg>
                      </div>
                      <span className="text-base sm:text-lg text-gray-800">Crafted by master artisans</span>
                    </li>
                    <li className="flex items-start gap-3 sm:gap-4">
                      <div className="flex-shrink-0 w-5 h-5 sm:w-6 sm:h-6 bg-gradient-to-br from-amber-600 to-orange-600 rounded-full flex items-center justify-center mt-1">
                        <svg className="w-3 h-3 sm:w-4 sm:h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                        </svg>
                      </div>
                      <span className="text-base sm:text-lg text-gray-800">High knot density for superior durability and fine detail</span>
                    </li>
                    <li className="flex items-start gap-3 sm:gap-4">
                      <div className="flex-shrink-0 w-5 h-5 sm:w-6 sm:h-6 bg-gradient-to-br from-amber-600 to-orange-600 rounded-full flex items-center justify-center mt-1">
                        <svg className="w-3 h-3 sm:w-4 sm:h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                        </svg>
                      </div>
                      <span className="text-base sm:text-lg text-gray-800">Made with premium wool, silk, or wool-silk blends</span>
                    </li>
                    <li className="flex items-start gap-3 sm:gap-4">
                      <div className="flex-shrink-0 w-5 h-5 sm:w-6 sm:h-6 bg-gradient-to-br from-amber-600 to-orange-600 rounded-full flex items-center justify-center mt-1">
                        <svg className="w-3 h-3 sm:w-4 sm:h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                        </svg>
                      </div>
                      <span className="text-base sm:text-lg text-gray-800">Long-lasting, heirloom-quality rugs</span>
                    </li>
                    <li className="flex items-start gap-3 sm:gap-4">
                      <div className="flex-shrink-0 w-5 h-5 sm:w-6 sm:h-6 bg-gradient-to-br from-amber-600 to-orange-600 rounded-full flex items-center justify-center mt-1">
                        <svg className="w-3 h-3 sm:w-4 sm:h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                        </svg>
                      </div>
                      <span className="text-base sm:text-lg text-gray-800">Ideal for residential and commercial interiors</span>
                    </li>
                  </ul>
                  <p className="mt-4 sm:mt-6 text-base sm:text-lg text-gray-800 italic text-center">
                    Every hand-knotted rug by Wovn Rugss is a one-of-a-kind masterpiece, ensuring authenticity and exclusivity.
                  </p>
                </div>
              </div>

              {/* Divider */}
              <div className="flex items-center justify-center max-w-4xl mx-auto">
                <div className="flex-1 h-px bg-gradient-to-r from-transparent via-amber-300 to-transparent"></div>
                <div className="mx-4 w-2 h-2 bg-amber-600 rounded-full"></div>
                <div className="flex-1 h-px bg-gradient-to-r from-transparent via-amber-300 to-transparent"></div>
              </div>

              {/* Making Process Section */}
              <div className="max-w-4xl mx-auto px-4">
                <h3 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-6 sm:mb-8 text-center">
                  Our Hand-Knotted Rug Making Process
                </h3>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
                  {[
                    { step: '1', title: 'Design & Pattern Development', desc: 'Each rug begins with a thoughtfully developed design inspired by traditional motifs and modern aesthetics.' },
                    { step: '2', title: 'Yarn Selection & Natural Dyeing', desc: 'We select high-quality natural yarns and hand-dye them to achieve rich, fade-resistant colors.' },
                    { step: '3', title: 'Hand Knotting on Loom', desc: 'Skilled artisans tie thousands to millions of individual knots by hand, ensuring precision, strength, and intricate detailing.' },
                    { step: '4', title: 'Washing, Trimming & Finishing', desc: 'Each rug is washed, trimmed, and finished to enhance texture, softness, and design clarity.' },
                    { step: '5', title: 'Final Quality Inspection', desc: 'Every hand-knotted rug undergoes strict quality checks before delivery.' }
                  ].map((process, index) => (
                    <div key={index} className="bg-white rounded-xl p-4 sm:p-6 shadow-lg hover:shadow-xl transition-shadow duration-300 border border-amber-100">
                      <div className="w-10 h-10 sm:w-12 sm:h-12 bg-gradient-to-br from-amber-600 to-orange-600 rounded-full flex items-center justify-center text-white font-bold text-lg sm:text-xl mb-3 sm:mb-4">
                        {process.step}
                      </div>
                      <h4 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">{process.title}</h4>
                      <p className="text-sm sm:text-base text-gray-700 leading-relaxed">{process.desc}</p>
                    </div>
                  ))}
                </div>
              </div>

              {/* Divider */}
              <div className="flex items-center justify-center max-w-4xl mx-auto">
                <div className="flex-1 h-px bg-gradient-to-r from-transparent via-amber-300 to-transparent"></div>
                <div className="mx-4 w-2 h-2 bg-amber-600 rounded-full"></div>
                <div className="flex-1 h-px bg-gradient-to-r from-transparent via-amber-300 to-transparent"></div>
              </div>

              {/* Custom Rugs Section */}
              <div className="max-w-4xl mx-auto px-4">
                <h3 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-4 sm:mb-6 text-center">
                  Custom Hand-Knotted Rugs by Wovn Rugss
                </h3>
                <div className="bg-gradient-to-br from-amber-50 via-orange-50 to-amber-50 rounded-2xl p-6 sm:p-8 md:p-10 shadow-lg">
                  <p className="text-base sm:text-lg text-gray-800 mb-4 sm:mb-6 text-center">
                    We specialize in custom hand-knotted rug manufacturing, tailored to your unique requirements.
                  </p>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 mb-4 sm:mb-6">
                    {[
                      'Custom sizes, shapes & layouts',
                      'Personalized colors & exclusive designs',
                      'Residential & hospitality projects',
                      'Interior designers and architects welcome'
                    ].map((item, index) => (
                      <div key={index} className="flex items-center gap-2 sm:gap-3">
                        <div className="flex-shrink-0 w-4 h-4 sm:w-5 sm:h-5 bg-gradient-to-br from-amber-600 to-orange-600 rounded-full flex items-center justify-center">
                          <svg className="w-2.5 h-2.5 sm:w-3 sm:h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                          </svg>
                        </div>
                        <span className="text-sm sm:text-base text-gray-800">{item}</span>
                      </div>
                    ))}
                  </div>
                  <p className="text-sm sm:text-base text-center text-gray-700 italic">
                    Ideal for luxury residences, boutique hotels, villas, resorts, and premium commercial spaces.
                  </p>
                </div>
              </div>

              {/* Divider */}
              <div className="flex items-center justify-center max-w-4xl mx-auto">
                <div className="flex-1 h-px bg-gradient-to-r from-transparent via-amber-300 to-transparent"></div>
                <div className="mx-4 w-2 h-2 bg-amber-600 rounded-full"></div>
                <div className="flex-1 h-px bg-gradient-to-r from-transparent via-amber-300 to-transparent"></div>
              </div>

              {/* Final Section */}
              <div className="max-w-4xl mx-auto text-center px-4">
                <p className="text-base sm:text-lg md:text-xl text-gray-700 leading-relaxed">
                  A hand-knotted rug from Wovn Rugss is more than a floor covering—it's an investment in craftsmanship, heritage, and timeless beauty. With proper care, our handmade rugs age gracefully and retain their value for decades.
                </p>
                <p className="text-base sm:text-lg md:text-xl text-gray-700 leading-relaxed mt-3 sm:mt-4 font-semibold">
                  Explore the collection of luxury handmade hand-knotted rugs by Wovn Rugss and experience authentic craftsmanship underfoot.
                </p>
              </div>
            </div>
          )}

          {/* Content Section - Hand Tufted Rugs */}
          {category === 'hand-tufted' && (
            <div className="mb-12 sm:mb-16 space-y-8 sm:space-y-12">
              {/* Introduction */}
              <div className="max-w-4xl mx-auto text-center px-4">
                <h3 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-900 mb-4 sm:mb-6">
                  Modern Craftsmanship. Refined Comfort.
                </h3>
                <p className="text-base sm:text-lg md:text-xl text-gray-700 leading-relaxed mb-4">
                  At Wovn Rugss, our hand-tufted rugs combine skilled craftsmanship with contemporary design. Each rug is handcrafted using a hand-tufting technique that allows greater design flexibility, rich textures, and faster production—without compromising on quality or aesthetics.
                </p>
                <p className="text-base sm:text-lg md:text-xl text-gray-700 leading-relaxed">
                  Made using premium wool, silk, or wool-silk blends, our hand-tufted rugs are ideal for modern homes, luxury apartments, hotels, and designer interiors.
                </p>
              </div>

              {/* Divider */}
              <div className="flex items-center justify-center max-w-4xl mx-auto">
                <div className="flex-1 h-px bg-gradient-to-r from-transparent via-amber-300 to-transparent"></div>
                <div className="mx-4 w-2 h-2 bg-amber-600 rounded-full"></div>
                <div className="flex-1 h-px bg-gradient-to-r from-transparent via-amber-300 to-transparent"></div>
              </div>

              {/* What Makes Special Section */}
              <div className="max-w-4xl mx-auto px-4">
                <h3 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-4 sm:mb-6 text-center">
                  What Makes Our Hand-Tufted Rugs Special?
                </h3>
                <div className="bg-gradient-to-br from-amber-50 via-orange-50 to-amber-50 rounded-2xl p-6 sm:p-8 md:p-10 shadow-lg">
                  <ul className="space-y-3 sm:space-y-4">
                    <li className="flex items-start gap-3 sm:gap-4">
                      <div className="flex-shrink-0 w-5 h-5 sm:w-6 sm:h-6 bg-gradient-to-br from-amber-600 to-orange-600 rounded-full flex items-center justify-center mt-1">
                        <svg className="w-3 h-3 sm:w-4 sm:h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                        </svg>
                      </div>
                      <span className="text-base sm:text-lg text-gray-800">Handcrafted by Skilled Artisans</span>
                    </li>
                    <li className="flex items-start gap-3 sm:gap-4">
                      <div className="flex-shrink-0 w-5 h-5 sm:w-6 sm:h-6 bg-gradient-to-br from-amber-600 to-orange-600 rounded-full flex items-center justify-center mt-1">
                        <svg className="w-3 h-3 sm:w-4 sm:h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                        </svg>
                      </div>
                      <span className="text-base sm:text-lg text-gray-800">Made with premium wool & silk fibers</span>
                    </li>
                    <li className="flex items-start gap-3 sm:gap-4">
                      <div className="flex-shrink-0 w-5 h-5 sm:w-6 sm:h-6 bg-gradient-to-br from-amber-600 to-orange-600 rounded-full flex items-center justify-center mt-1">
                        <svg className="w-3 h-3 sm:w-4 sm:h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                        </svg>
                      </div>
                      <span className="text-base sm:text-lg text-gray-800">Soft, plush, and comfortable underfoot</span>
                    </li>
                    <li className="flex items-start gap-3 sm:gap-4">
                      <div className="flex-shrink-0 w-5 h-5 sm:w-6 sm:h-6 bg-gradient-to-br from-amber-600 to-orange-600 rounded-full flex items-center justify-center mt-1">
                        <svg className="w-3 h-3 sm:w-4 sm:h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                        </svg>
                      </div>
                      <span className="text-base sm:text-lg text-gray-800">Contemporary & customizable designs</span>
                    </li>
                    <li className="flex items-start gap-3 sm:gap-4">
                      <div className="flex-shrink-0 w-5 h-5 sm:w-6 sm:h-6 bg-gradient-to-br from-amber-600 to-orange-600 rounded-full flex items-center justify-center mt-1">
                        <svg className="w-3 h-3 sm:w-4 sm:h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                        </svg>
                      </div>
                      <span className="text-base sm:text-lg text-gray-800">Embossed and carved pile options available</span>
                    </li>
                    <li className="flex items-start gap-3 sm:gap-4">
                      <div className="flex-shrink-0 w-5 h-5 sm:w-6 sm:h-6 bg-gradient-to-br from-amber-600 to-orange-600 rounded-full flex items-center justify-center mt-1">
                        <svg className="w-3 h-3 sm:w-4 sm:h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                        </svg>
                      </div>
                      <span className="text-base sm:text-lg text-gray-800">Excellent quality at a competitive price point</span>
                    </li>
                  </ul>
                  <p className="mt-4 sm:mt-6 text-base sm:text-lg text-gray-800 italic text-center">
                    Hand-tufted rugs by Wovn Rugss offer the perfect balance of luxury, comfort, and modern style.
                  </p>
                </div>
              </div>

              {/* Divider */}
              <div className="flex items-center justify-center max-w-4xl mx-auto">
                <div className="flex-1 h-px bg-gradient-to-r from-transparent via-amber-300 to-transparent"></div>
                <div className="mx-4 w-2 h-2 bg-amber-600 rounded-full"></div>
                <div className="flex-1 h-px bg-gradient-to-r from-transparent via-amber-300 to-transparent"></div>
              </div>

              {/* Making Process Section */}
              <div className="max-w-4xl mx-auto px-4">
                <h3 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-6 sm:mb-8 text-center">
                  Our Hand-Tufted Rug Making Process
                </h3>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
                  {[
                    { step: '1', title: 'Design & Layout', desc: 'Each rug begins with a carefully developed design, created to suit modern and luxury interior spaces.' },
                    { step: '2', title: 'Canvas Stretching', desc: 'A durable canvas is stretched tightly on a frame to prepare the base for tufting.' },
                    { step: '3', title: 'Hand Tufting', desc: 'Using a hand-tufting gun, artisans insert yarn into the canvas to form the rug\'s pattern and texture.' },
                    { step: '4', title: 'Latex Backing & Finishing', desc: 'The back is reinforced with latex for durability, followed by carving, embossing, trimming, and washing.' },
                    { step: '5', title: 'Final Quality Check', desc: 'Every hand-tufted rug is inspected to ensure consistency, softness, and premium finish.' }
                  ].map((process, index) => (
                    <div key={index} className="bg-white rounded-xl p-4 sm:p-6 shadow-lg hover:shadow-xl transition-shadow duration-300 border border-amber-100">
                      <div className="w-10 h-10 sm:w-12 sm:h-12 bg-gradient-to-br from-amber-600 to-orange-600 rounded-full flex items-center justify-center text-white font-bold text-lg sm:text-xl mb-3 sm:mb-4">
                        {process.step}
                      </div>
                      <h4 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">{process.title}</h4>
                      <p className="text-sm sm:text-base text-gray-700 leading-relaxed">{process.desc}</p>
                    </div>
                  ))}
                </div>
              </div>

              {/* Divider */}
              <div className="flex items-center justify-center max-w-4xl mx-auto">
                <div className="flex-1 h-px bg-gradient-to-r from-transparent via-amber-300 to-transparent"></div>
                <div className="mx-4 w-2 h-2 bg-amber-600 rounded-full"></div>
                <div className="flex-1 h-px bg-gradient-to-r from-transparent via-amber-300 to-transparent"></div>
              </div>

              {/* Custom Rugs Section */}
              <div className="max-w-4xl mx-auto px-4">
                <h3 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-4 sm:mb-6 text-center">
                  Custom Hand-Tufted Rugs by Wovn Rugss
                </h3>
                <div className="bg-gradient-to-br from-amber-50 via-orange-50 to-amber-50 rounded-2xl p-6 sm:p-8 md:p-10 shadow-lg">
                  <p className="text-base sm:text-lg text-gray-800 mb-4 sm:mb-6 text-center">
                    We specialize in custom hand-tufted rug manufacturing, tailored to your exact requirements.
                  </p>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 mb-4 sm:mb-6">
                    {[
                      'Custom sizes & shapes',
                      'Personalized colors & patterns',
                      'Embossed / high-low pile designs',
                      'Ideal for residential & hospitality projects'
                    ].map((item, index) => (
                      <div key={index} className="flex items-center gap-2 sm:gap-3">
                        <div className="flex-shrink-0 w-4 h-4 sm:w-5 sm:h-5 bg-gradient-to-br from-amber-600 to-orange-600 rounded-full flex items-center justify-center">
                          <svg className="w-2.5 h-2.5 sm:w-3 sm:h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                          </svg>
                        </div>
                        <span className="text-sm sm:text-base text-gray-800">{item}</span>
                      </div>
                    ))}
                  </div>
                  <p className="text-sm sm:text-base text-center text-gray-700 italic">
                    Perfect for living rooms, bedrooms, offices, hotels, and boutique interiors.
                  </p>
                </div>
              </div>

              {/* Divider */}
              <div className="flex items-center justify-center max-w-4xl mx-auto">
                <div className="flex-1 h-px bg-gradient-to-r from-transparent via-amber-300 to-transparent"></div>
                <div className="mx-4 w-2 h-2 bg-amber-600 rounded-full"></div>
                <div className="flex-1 h-px bg-gradient-to-r from-transparent via-amber-300 to-transparent"></div>
              </div>

              {/* Final Section */}
              <div className="max-w-4xl mx-auto text-center px-4">
                <h3 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-900 mb-3 sm:mb-4">
                  Designed for Modern Living
                </h3>
                <p className="text-base sm:text-lg md:text-xl text-gray-700 leading-relaxed">
                  Hand-tufted rugs from Wovn Rugss are designed for those who seek style, comfort, and versatility. With proper care, they maintain their beauty and texture for years while elevating any interior space.
                </p>
                <p className="text-base sm:text-lg md:text-xl text-gray-700 leading-relaxed mt-3 sm:mt-4 font-semibold">
                  Explore our collection of luxury hand-tufted rugs and experience modern craftsmanship at its finest.
                </p>
              </div>
            </div>
          )}

          {/* Collage Grid - Masonry Style Layout */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4 md:gap-6 px-4 sm:px-0">
            {currentCollageImages.map((image, index) => (
              <div
                key={index}
                className="group relative overflow-hidden rounded-2xl shadow-xl hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 cursor-pointer"
                onClick={() => setSelectedImage(image)}
              >
                <div className="relative aspect-[4/3] overflow-hidden bg-gradient-to-br from-amber-50 to-orange-50">
                  <img
                    src={image}
                    alt={category === 'hand-tufted' ? `Modern hand tufted rug ${index + 1} for living room by Wovn Rugss – wovnrugss.com` : `Luxury hand knotted wool rug ${index + 1} by Wovn Rugss – wovnrugss.com`}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                    loading="lazy"
                    onError={(e) => {
                      e.target.src = 'https://images.unsplash.com/photo-1600166898405-da9535204843?w=600&h=800&fit=crop';
                    }}
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                  <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                    <div className="bg-white/90 backdrop-blur-sm rounded-full p-4 transform group-hover:scale-110 transition-transform">
                      <svg className="w-8 h-8 text-amber-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM10 7v3m0 0v3m0-3h3m-3 0H7" />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Image Modal */}
      {selectedImage && (
        <div
          className="fixed inset-0 z-50 bg-black/90 backdrop-blur-sm flex items-center justify-center p-2 sm:p-4"
          onClick={() => setSelectedImage(null)}
        >
          <div className="relative max-w-7xl max-h-[95vh] sm:max-h-[90vh] w-full h-full flex items-center justify-center">
            <img
              src={selectedImage}
              alt="Luxury handcrafted rug detail by Wovn Rugss – wovnrugss.com"
              className="max-w-full max-h-full object-contain rounded-lg"
              onClick={(e) => e.stopPropagation()}
            />
            <button
              onClick={() => setSelectedImage(null)}
              className="absolute top-2 right-2 sm:top-4 sm:right-4 bg-white/90 hover:bg-white text-gray-900 rounded-full p-2 sm:p-3 transition-all duration-300 transform hover:scale-110"
              aria-label="Close"
            >
              <svg className="w-5 h-5 sm:w-6 sm:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default ProductsList;
